// removed by extract-text-webpack-plugin
module.exports = {"ModalBody":"ModalBody","ConfirmCashTransfer":"ConfirmCashTransfer","progressStep":"progressStep","active":"active","activeText":"activeText","StepNumber":"StepNumber","StepTitle":"StepTitle","CashTransferInternalContent":"CashTransferInternalContent"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/CashTransfer1/CashTransferInternalSub/styles.scss
// module id = 2228
// module chunks = 10